import { render } from "./Site.vue?vue&type=template&id=49ba681f&scoped=true"
import script from "./Site.vue?vue&type=script&lang=js"
export * from "./Site.vue?vue&type=script&lang=js"

import "./Site.vue?vue&type=style&index=0&id=49ba681f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ba681f"]])

export default __exports__